import React, {Component} from 'react';
import NavList from '../widgets/NavList';
import NavListItem from '../widgets/NavListItem';
import {connect} from 'react-redux';
import {actions} from './syllabus.state'
import {matchPath} from 'react-router';
import handleError from '../handleError';
import jsonFetch from '../jsonFetch';
import debounce from '../debounce';
import {actions as dirtyActions} from '../dirty.state';
import {push} from 'react-router-redux';
import {getSortedSets, setRetrievingSelector} from './set.selectors';
import './SetList.css';

const isSetSelected = location => {
	return matchPath(location.pathname, {
		path: '/set/:setID',
		exact: false,
		strict: false
	});
};

export class SetList extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			search: ''
		};

		if (!props.items || !props.items.length || !isSetSelected(props.location)) {
			this.fetchSetListData(props);
		}
		
		/**
		 * Actually perform the search on the back-end
		 */
		const doSearch = value => {
			props.setListRetrieving([]);
			jsonFetch(`${process.env.REACT_APP_API}/set?query=${encodeURIComponent(value)}`)
				.then(json => props.setListRetrieved(json))
				.catch(e => {
					props.setListRetrieved([]); // To prevent indefinite loading animation
					props.handleError(e);
				});
		};

		const doSearchAfterDelay = debounce(doSearch, 500);
		this.doSearchAfterDelay = e => doSearchAfterDelay(e.target.value.trim());

		this.onSearchChange = e => {
			this.setState({search: e.target.value});
			this.doSearchAfterDelay(e);
		};

		/**
		 * Allows convenient searching by a given category by selecting that category in the set list.
		 */
		this.applyCategorySearch = (e, set) => {
			if (!set) return;
			e.preventDefault();
			e.stopPropagation();
			this.setState({search: set.category});
			doSearch(set.category);
		};

		/**
		 * Allows convenient searching for syllabus sets with versions in a given state.
		 */
		const applyPredefinedSearch = search => e => {
			e.preventDefault();
			e.stopPropagation();
			this.setState({search});
			doSearch(search);
		};

		this.applyDraftsSearch = applyPredefinedSearch('has:drafts');
		this.applyPublishedSearch = applyPredefinedSearch('has:published');
		this.applyApprovedSearch = applyPredefinedSearch('has:approved');
	}
	
	fetchSetListData = ({setID, setListRetrieving, setListRetrieved, handleError}) => {
		setListRetrieving([]);
			jsonFetch(`${process.env.REACT_APP_API}/set`)
				.then(json => setListRetrieved(json))
				.catch(handleError);
	};
	
	componentWillReceiveProps(nextProps) {
		if (this.props.setID !== nextProps.setID) {
			this.fetchSetListData(nextProps);
		}
	}
	
	render() {
		const {
			isDirty,
			newSet,
			items,
			retrieving
		} = this.props;
		
		return (
			<NavList
				className="SetList"
				theme="green"
				loading={retrieving}
				disabled={isDirty}
				onSearchChange={this.onSearchChange}
				onAdd={newSet}
				managedSearch={true}
				searchValue={this.state.search}
			>
				{items.map(set => (
					<NavListItem
						key={set.uuid}
						to={`/set/${set.uuid}`}
						backgroundUrl={set.imagePath}
						name={set.name}
						status={set.status}
						theme="green"
						disabled={isDirty}
					>
						<p>Geographical region: <em>{set.region}</em></p>
						{set.category ? (
							<div
								className="SetList-item-category"
								onClick={e => this.applyCategorySearch(e, set)}
							>
								{set.category}
							</div>
						) : undefined}
						{set.publishedVersions || set.approvedDraftVersions || set.unapprovedDraftVersions ? (
							<div className="SetList-item-versionState">
								{set.publishedVersions ? (
									<span onClick={this.applyPublishedSearch} className="SetList-item-versionState-published"><em>{set.publishedVersions}</em> published</span>
								) : undefined}
								{set.approvedDraftVersions ? (
									<span onClick={this.applyApprovedSearch} className="SetList-item-versionState-ready"><em>{set.approvedDraftVersions}</em> ready for publishing</span>
								) : undefined}
								{set.unapprovedDraftVersions ? (
									<span onClick={this.applyDraftsSearch} className="SetList-item-versionState-draft"><em>{set.unapprovedDraftVersions}</em> draft</span>
								) : undefined}
							</div>
						) : undefined}
					</NavListItem>
				))}
			</NavList>
		);
	}
}

const ConnectedSetList = connect(
	state => ({
		isDirty: !!(state.dirty && state.dirty.keys && Object.keys(state.dirty.keys).length),
		retrieving: setRetrievingSelector(state),
		items: getSortedSets(state)
	}),
	dispatch => ({
		setListRetrieving: () => dispatch(actions.setListRetrieving()),
		setListRetrieved: data => dispatch(actions.setListRetrieved(data)),
		handleError: handleError(dispatch),
		newSet: () => {
			dispatch(actions.setNew());
			dispatch(push('/set/new'));
			dispatch(dirtyActions.dirtySet('new'));
		},
	})
)(SetList);

export default ConnectedSetList;


// WEBPACK FOOTER //
// ./src/syllabus/SetList.js